import comp from "./StandardsTable";
export default comp;
